import React, { useState, useRef } from "react";
import { Formik, Form, Field } from "formik";
import { useParams, Link } from "react-router-dom";
import * as Yup from "yup";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import { useEffect } from "react";
import axios from "axios";
import config from "../../../../config/config";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  CUSTOM_SELECT_DROPDOWN_STYLE
} from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import { toastError, toastSuccess } from "../../../../common/Toast";

const Details = (props) => {
  const buttonRef = React.useRef();
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const [manufacturedropdwonData, setManufactureDropdwon] = useState([]);
  const [selectmanufacturedropdwonData, setselectmanufacturedropdwonData] =
    useState([]); // set in this selected values
  const [checked, setChecked] = useState(true);
  const [show, setShow] = useState(false); //Show the Categories model
  const [showtag, setShowTag] = useState(false); //Show the Tags model
  const [showManufacture, setShowManufacture] = useState(false); //Show the Manufacture model
  const [check, setCheck] = useState([]);
  const [Modifiers, setModifiers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [tagsdropdwonData, setTagsdropdwonData] = useState([]); // tags values stores
  const [selectedtags, setSelectedtags] = useState(""); //store seletcd tags

  const ActionButtons = (props) => {};
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  // const handleNext = () => {
  //   props.nextStep();
  //   window.scrollTo(0, 0);
  // };

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  const [formValues, setFormValues] = useState({
    ProductId: "",
    Tags: "",
    Description: "",
    ImPOP: "",
    DefaultQuantity: parseFloat(0.0).toFixed(2),
    Manufacture: "",
    Inactive: false,
    IsBarcoded: false,
    IsFavorite: false,
  });

  const validationSchema = Yup.object().shape({
    ProductId: Yup.string().required("ProductId is required"),
  });

  var isCheck = (item) =>
    check.includes(item.ID) ? "checked-item" : "not-checked-item";

  // dropdown of manufature
  let Manufacturerdropdown = [];
  const manufacturedropdownvalue = manufacturedropdwonData.map((u, i) => {
    Manufacturerdropdown[i] = { label: u.Name, value: u.ID };
  });

  //tags comma separated
  let TagsList = [];
  const Tags = tagsdropdwonData.map((u, i) => {
    TagsList[i] = { label: u.Name, value: u.ID };
  });

  // close and show model pop
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handeltagsmodelClose = () => setShowTag(false);
  const handeltagsmodelShow = () => setShowTag(true);
  const handleManufactureClose = () => setShowManufacture(false);
  const handleManufactureShow = () => setShowManufacture(true);

  const handleDropdowns = (selectedIds) => {
    // manufacture dropdon values
    axios
      .get(
        `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setManufactureDropdwon(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(
        `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setManufactureDropdwon(res.data.ResponseData);
        if (selectedIds != undefined) {
          // Binding Manufactures data
          let ManufactureList = res.data.ResponseData;

          ManufactureList.map((selectedManufacture) => {
            if (selectedManufacture.ID == selectedIds) {
              setselectmanufacturedropdwonData({
                label: selectedManufacture.Name,
                value: selectedManufacture.ID,
              });
            }
          });
        }
        // setLoading(false);
        return res;
      });
  };
  const handleTagsDropdowns = (seletedId) => {
    // tags dropdown values
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagsdropdwonData(res.data.ResponseData);

        return res;
      });
  };

  const [formValuesfortagmodel, setFormValuesforTagmodel] = useState({
    ID: 0,
    Tags: "",
  });

  const [formValuesformenufacturemodel, setFormValuesforMenufacturemodel] =
    useState({
      ID: 0,
      Manufacture: "",
    });

  //changes in selected in Tags
  const handleSelectedtags = (e) => {
    setSelectedtags(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  // handleSubmit for tags model
  const handleSubmitformodeltags = async (eventObject) => {
    setLoading(true);
    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: 0,
          ecommerecetagid: 1,
          name: eventObject.Tags,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);

        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleTagsDropdowns();
          setSelectedtags([...selectedtags, res.data.ResponseID]);
          setselectmanufacturedropdwonData(selectmanufacturedropdwonData);
          const clearData = {
            ID: 0,
            Tags: "",
          };
          let fixvalues = formValues;
          setFormValues(fixvalues);
          setFormValuesforTagmodel(clearData);
          setShowTag(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  // handlesubmit for manufacture model
  const handleSubmitformodelManufacture = async (eventObject) => {
    // console.log(eventObject.Manufacture);
    // setLoading(true);
    axios
      .post(
        `${config.manufacturerBaseUrl}/manufacturers/upsert`,
        {
          id: 0,
          isactive: 1,
          name: eventObject.Manufacture,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // // console.log(res);
        // console.log(res.data.ResponseID);
        if (res.data.ResponseCode === "SUCCESS") {
          console.log(res.data);
          toastSuccess(SUCCESS_MESSAGE);
          const clearData = {
            ID: 0,
            Manufacture: "",
          };
          console.log(formValues);
          let fixvalues = formValues;
          setFormValues(fixvalues);
          setSelectedtags(selectedtags);
          handleDropdowns(res.data.ResponseID);
          setFormValuesforMenufacturemodel(clearData);
          handleManufactureClose();
          // setShowTag(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  //details upsert
  const handleSubmit = (value) => {
    let ItemKitsDetails = {
      id: paramObject.id,
      manufacturerid: selectmanufacturedropdwonData.value,
      productid: value.ProductId,
      description: value.Description,
      infopopup: value.ImPOP,
      iteminactive: value.Inactive === true ? 1 : 0,
      isbarcoded: value.IsBarcoded === true ? 1 : 0,
      isfavorite: value.IsFavorite === true ? 1 : 0,
      defaultquantity: parseFloat(value.DefaultQuantity),
      loginuserid: loginUserId,
      tagsids: selectedtags.toString(),
    };

    setLoading(true);
    axios
      .post(
        `${config.itemKitsBaseUrl}/itemkits/itemkitsdetails`,
        ItemKitsDetails,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          props.nextStep();
          window.scrollTo(0, 0);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  //details data binding
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${config.itemKitsBaseUrl}/itemkits/itemsdetailselectbyid?id=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          //console.log("::__", res.data.ResponseData.ItemKits[0]);
          let data = res.data.ResponseData.ItemKits[0];
          handleTagsDropdowns();

          // for bind the tags values
          if (data.TagId.length > 0) {
            axios
              .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              })
              .then((res) => {
                // console.log("::>>>", res);
                TagsList = res.data.ResponseData;
                if (data.TagId.length > 0) {
                  TagsList.map((selectManufacturer) => {
                    const splitSelectedManufacturer = data.TagId.split(",");

                    // using map() to convert array of strings to numbers
                    var splitSelectedManufacturernumbers =
                      splitSelectedManufacturer.map(function (str) {
                        return parseInt(str);
                      });
                    setSelectedtags(splitSelectedManufacturernumbers);
                  });
                }
              });
          }
          const itemkitsdata = {
            ProductId: data.ProductId,
            Description: data.Description,
            ImPOP: data.ImPOP,
            DefaultQuantity: parseFloat(data.DefaultQuantity),
            Inactive: data.Inactive === 1 ? true : false,
            IsBarcoded: data.IsBarcoded === 1 ? true : false,
            IsFavorite: data.IsFavorite === 1 ? true : false,
          };
          setFormValues(itemkitsdata);

          handleDropdowns(res.data.ResponseData.ItemKits[0].ManufacturerId);
          handleDropdowns();
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  }, []);

  // const handleNext = () => {
  //   handleSubmit();
  //   props.nextStep();
  //   window.scrollTo(0, 0);
  // };

  function handleButtonClick() {
    if (buttonRef.current.getAttribute("data-page") === "specific-page") {
      buttonRef.current.click();
      console.log("Button 1 clicked and Button 2 triggered");
    }
  }

  return (
    <>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title">
            Item Details
            {/* (Fields in <span className="text-danger">*</span>
            are required) */}
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-primary btn-md me-1"
              >
                Back
              </button>
            )}
            {props.currentStep < props.totalSteps && (
              <button
                //onClick={handleNext}
                className="btn btn-primary btn-md"
                type="button"
                onClick={handleButtonClick}
              >
                Next
              </button>
            )}
          </div>
        </div>

        <Formik
          {...props}
          validationSchema={validationSchema}
          initialValues={formValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, handleChange }) => (
            <Form>
              <div className="card-body">
                <div className="row">
                  {/* Product ID */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-2">
                        Product ID<span className="text-danger">*</span>
                      </label>
                      <div className="col-10">
                        <Field
                          type="text"
                          className={`form-control ${
                            errors.ProductId ? "is-invalid" : ""
                          }`}
                          id="ProductId"
                          name="ProductId"
                          onChange={handleChange}
                        />
                        <div className="invalid-feedback">
                          {touched.ProductId && errors.ProductId
                            ? errors.ProductId
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tags */}
                <div className="row mt-3">
                  <label className="form-label col-md-1">Tags</label>
                  <div className="col-md-11">
                    <div className="input-group">
                      <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        isMulti={true}
                        onChange={handleSelectedtags}
                        options={TagsList}
                        placeholder=""
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        value={TagsList.filter((obj) =>
                          selectedtags.includes(obj.value)
                        )}
                        id="Tags"
                        name="Tags"
                        className="w-75"
                      />
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModal"
                        onClick={() => handeltagsmodelShow()}
                      >
                        Add Tags
                      </button>
                    </div>
                  </div>
                </div>

                {/* model for Tags Add*/}
                <Modal
                  show={showtag}
                  onHide={handleClose}
                  className="modal-lg"
                  id="ManageDataModal"
                >
                  <Modal.Header>
                    <Modal.Title>Add Tags </Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handeltagsmodelClose}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesfortagmodel}
                    onSubmit={handleSubmitformodeltags}
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form>
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Tags
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="Tags"
                                id="Tags"
                                
                                placeholder="Enter Tag Name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-primary btn-md me-2"
                            >
                              Submit
                            </button>
                            <button
                              className="btn btn-dark btn-md me-1"
                              onClick={handeltagsmodelClose}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Manufacturer */}
                <div className="row mt-3">
                  <label className="form-label col-md-1">Manufacturer</label>
                  <div className="col-md-11">
                    <div className="input-group">
                      <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        onChange={setselectmanufacturedropdwonData}
                        options={Manufacturerdropdown}
                        placeholder=""
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        value={
                          Manufacturerdropdown.find(
                            (option) =>
                              option.value ===
                              selectmanufacturedropdwonData.value
                          ) || ""
                        }
                        id="Manufacturer"
                        name="Manufacturer"
                        className="w-75"
                      />
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModalManufacture"
                        onClick={() => handleManufactureShow()}
                      >
                        Manage Manufacturer
                      </button>
                    </div>
                  </div>
                </div>

                {/* manufacure Model */}
                <Modal
                  show={showManufacture}
                  onHide={handleManufactureClose}
                  className="modal-lg"
                  id="ManageDataModalManufacture"
                >
                  <Modal.Header>
                    <Modal.Title>Add Manufacture</Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleManufactureClose}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesformenufacturemodel}
                    onSubmit={handleSubmitformodelManufacture}
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form>
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Manufacture
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="Manufacture"
                                id="Manufacture"
                                placeholder="Enter Manufacture Name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-primary btn-md me-2"
                            >
                              Submit
                            </button>
                            <button
                              className="btn btn-dark btn-md me-1"
                              onClick={handleManufactureClose}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Description */}

                <div className="row mt-3">
                  <label className="form-label col-md-1">
                    Item Kit Description
                  </label>
                  <div className="col-md-11 mb-3">
                    <Field
                      name="Description"
                      id="Description"
                      cols="19"
                      rows="3"
                      className="form-control text-area"
                      as="textarea"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Information Popup */}
                <div className="row mt-3">
                  <label className="form-label col-md-1">
                    Information Popup When Adding To Sale
                  </label>
                  <div className="col-md-11">
                    <Field
                      name="ImPOP"
                      id="ImPOP"
                      cols="17"
                      rows="3"
                      className="form-control text-area"
                      as="textarea"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row">
                  {/* Inactive */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="form-check-label col-md-2">
                        Inactive
                      </label>
                      <div className="col-md-10 mb-3">
                        <Field
                          type="checkbox"
                          style={{ width: "1.25em", height: "1.25em" }}
                          className="checkbox form-check-input me-3"
                          id="Inactive"
                          name="Inactive"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* Barcoded */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="form-check-label col-md-2">
                        Is Barcoded
                      </label>
                      <div className="col-md-10 mb-3">
                        <Field
                          type="checkbox"
                          style={{ width: "1.25em", height: "1.25em" }}
                          className="checkbox form-check-input me-3"
                          id="IsBarcoded"
                          name="IsBarcoded"
                          onChange={handleChange}
                        />
                      </div>

                      {/* Favorite */}
                      <label className="form-check-label col-md-2">
                        Is Favorite
                      </label>
                      <div className="col-md-10 mb-3">
                        <Field
                          type="checkbox"
                          style={{ width: "1.25em", height: "1.25em" }}
                          className="checkbox form-check-input me-3"
                          id="IsFavorite"
                          name="IsFavorite"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Default Quantity */}
                  <div className="mt-3 row">
                    <div className="col-md-1">
                      <label className="form-label">
                        Default Quantity When Selling Or Receiving
                      </label>
                    </div>
                    <div className="col-md-11 mb-3">
                      <Field
                        type="text"
                        className="form-control"
                        id="DefaultQuantity"
                        name="DefaultQuantity"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  {props.currentStep > 1 && (
                    <button
                      onClick={handleBack}
                      className="btn btn-primary me-3"
                    >
                      Back
                    </button>
                  )}
                  {props.currentStep < props.totalSteps && (
                    <button
                      className="btn btn-primary"
                      type="submit"
                      data-page="specific-page"
                      ref={buttonRef}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <ActionButtons {...props} />
      </div>
    </>
  );
};

export default Details;
